import { render, staticRenderFns } from "./ReportTemplateList.vue?vue&type=template&id=e6046928&"
import script from "./ReportTemplateList.vue?vue&type=script&lang=js&"
export * from "./ReportTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports